export const END_CALL = 'END_CALL';
export const END_CALL_FAILED = 'END_CALL_FAILED';
export const END_CALL_SUCCESS = 'END_CALL_SUCCESS';
export const GET_CALL_DATA = 'GET_CALL_DATA';
export const GET_CALL_DATA_FAILED = 'GET_CALL_DATA_FAILED';
export const GET_CALL_DATA_SUCCESS = 'GET_CALL_DATA_SUCCESS';
export const GET_PARTICIPANTS = 'GET_PARTICIPANTS';
export const GET_PARTICIPANTS_FAILED = 'GET_PARTICIPANTS_FAILED';
export const GET_PARTICIPANTS_SUCCESS = 'GET_PARTICIPANTS_SUCCESS';
export const UPDATE_PARTICIPANT_STATUS = 'UPDATE_PARTICIPANT_STATUS';
export const SET_PARTICIPANT_STATUS = 'SET_PARTICIPANT_STATUS';
export const UPDATE_PARTICIPANTS_PERMITS = 'UPDATE_PARTICIPANTS_PERMITS';
export const SET_PARTICIPANTS_PERMITS = 'SET_PARTICIPANTS_PERMITS';
export const SET_PARTICIPANTS_PERMITS_FAILED = 'SET_PARTICIPANTS_PERMITS_FAILED';
export const SET_PARTICIPANTS_PERMITS_SUCCESS = 'SET_PARTICIPANTS_PERMITS_SUCCESS';
export const SET_PARTICIPANT_STATE = 'SET_PARTICIPANT_STATE';
export const UPDATE_PARTICIPANT_STATE = 'UPDATE_PARTICIPANT_STATE';
